export class UserNotFoundError extends Error {
  private email: string;

  constructor(
    email: string,
    message: string = `User with email ${email} not found.`,
  ) {
    super(message);
    this.name = 'UserNotFoundError';
    this.email = email;
  }
}
